













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Helpers
 */
import { getFullName } from '@/utils/users-helpers';
import { getElegantDateString, getDateString } from '@/utils/date-helpers';
import { sortByAsc } from '@/utils/sort-helpers';

/**
 * Mixins
 */
import mixinsBooking from '@/mixins/booking-mixins';

/**
 * API
 */
import bookingsAPI from '@/api/bookings';

/**
 * Components
 */

/**
 * Types
 */
import { BookingState, BookingCategory, BookingActiveState } from '@/api/bookings';
import { FilterModel } from '@/components/_global/FilterControl.vue';

/**
 * Page de liste des réservations de passage (TODO).
 */
@Component({
	mixins: [mixinsBooking]
})
export default class BookingsListPage extends Vue {
	/** Injections */
	bookingState = BookingState;
	getFullName = getFullName;
	getElegantDateString = getElegantDateString;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	filterModel: FilterModel | null = null;
	bookingsList: any[] = [];
	pagination = {
		sortBy: 'bookedDate',
		descending: true,
	};
	headers = [
		{
			text: 'booking.service',
			value: 'service.label',
			align: 'left'
		},
		{
			text: 'booking.user',
			value: 'user.lastName',
			align: 'left'
		},
		{
			text: 'booking.booking_date',
			value: 'bookingDate',
			align: 'left'
		},
		{
			text: 'booking.booked_date',
			value: 'bookedDate',
			align: 'left'
		},
		{
			text: 'booking.state',
			value: 'state',
			align: 'left'
		}
	];

	get filtersDefinitions() {
		const fd: any = {};

		fd.SERVICE = {
			label: this.$t('booking.service'),
			value: (x: any) => x.label,
			key: 'id',
			items: this.bookingsList.reduce((acc, curr) => [...acc, curr.service], []).sort(sortByAsc((x) => x.label)),
			f: (keySelected: string) => (x: any) => x.service.id === keySelected,
			placeholder: this.$t('booking.all_services')
		};

		fd.BOOKED_DATE = {
			label: this.$t('booking.booked_date'),
			value: (x: any) => x.value,
			key: 'key',
			items: this.bookingsList.reduce((acc, curr) => {
				const bookedDate = new Date(Date.parse(curr.bookedDate));
				const bookedDateKey = `${getDateString(bookedDate)}`;
				const bookedDateValue = `${getElegantDateString(bookedDate)}`;
				return [...acc, {
					key: bookedDateKey,
					value: bookedDateValue
				}];
			}, []).sort(sortByAsc((x) => x.key)),
			f: (keySelected: string) => (x: any) => {
				return getDateString(new Date(Date.parse(x.bookedDate))) === getDateString(new Date(Date.parse(keySelected)));
			},
			placeholder: this.$t('booking.all_dates')
		};
		fd.STATE = {
			label: this.$t('booking.state'),
			value: (x: any) => x.value,
			key: 'key',
			items: this.bookingsList.reduce((acc, curr) => {
				return [...acc, {
					key: curr.state,
					value: (this as any).stateToText(curr.state)
				}];
			}, []).sort(sortByAsc((x) => x.key)),
			f: (keySelected: string) => (x: any) => {
				return keySelected === x.state;
			},
			placeholder: this.$t('booking.all_states')
		};
		return fd;
	}

	get displayedBookingsList() {
		return this.filterModel ? this.bookingsList.filter(this.filterModel.predicate) : this.bookingsList;
	}

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.fetchAll();
		this.isLoading = false;
	}

	async fetchAll() {
		this.bookingsList = await bookingsAPI.getAllUpcoming(BookingCategory.PASSAGES, true, BookingActiveState.ALL);
	}
}
